import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

export const muiStyles = (theme: ApplicationMuiTheme) => ({
    headerContainer: {},
    headerText: {
        fontSize: '1rem',
        padding: '0 .5rem',
        '&:first-child': { paddingLeft: 0 }
    },
    headerDetailsContainer: { padding: '1.5rem 0' },
    approvalButtonContainer: {
        width: 'auto' as const,
        marginLeft: 'auto' as const,
        paddingRight: '4rem'
    },
    headerSmallDetail: {
        width: 'auto' as const,
        paddingRight: '2rem'
    },
    headerLabel: {
        fontSize: '.75rem',
        lineHeight: '1.2rem',
        color: theme?.app?.applicationColors.enumColors.greyDark ||
            '#333333',
        paddingRight: '.5rem'
    },
    headerAttribute: {
        fontSize: '.9rem',
        lineHeight: '1.2rem',
        fontWeight: 'bold' as const,
        textTransform: 'uppercase' as const
    }
});